export default "__VITE_ASSET__DgldWvju__"